module.exports = __webpack_public_path__ + "img/news-8.bb6b4b6a.png";